// ⚠️ Este arquivo é gerado automaticamente via generate-env.js
export const environment = {
  production: false,
  apiUrl: 'https://gemminus-lakehouse-dev.enacloud.me',
  socketUrl: 'https://gemminus-lakehouse-dev.enacloud.me',
  urlFront: 'plataforma-dados-dev.enacloud.me',
  redirectUri: 'plataforma-dados-dev.enacloud.me',

  apiUrlBuffer: '',
  token: '',

  // ENACOM
  client: 'f3685b6e-ca89-492b-b22b-c03866066741',
  authority: 'https://login.microsoftonline.com/efa10a2e-43c9-4e1e-8b6f-e1dd91403848',
};
